
const ConsoleType : any =  {
   Error: "error",
};

export default ConsoleType;